<template>
  <div v-rect-loading="loading" class="applied-potential-page">
    <div class="applied-potential-container">
      <div v-if="companyId && !wxUserHasBindRewards" class="get-rewards">
        <el-button class="get-rewards-btn" @click="handleGetQrCode">{{ $t('personal.referrals.rewards.label.getRewards') }}</el-button>
      </div>
      <ReferralCard
        v-for="(applied, index) in potentialList"
        class="applied-potential-list"
        isAppliedList
        :key="index"
        :referralInfo="applied"
      >
        <template #status>
          <div class="status">{{ $t(`admin.application.candidate.STATUS_GROUP.${applied.group_status_name}`) }}</div>
        </template>
      </ReferralCard>
    </div>
    <div v-if="!potentialList || potentialList.length < 1" class="tip">{{ $t(`${i18nPrefix}.message.appliedNoData`) }}</div>
    <WeChatBindQrCodeDialog
      :show.sync="showWeChatBindQrCodeDialog"
      :companyId="companyId"
      :isPc="isPc"
    ></WeChatBindQrCodeDialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import ReferralCard from './referralCard.vue'
import WeChatBindQrCodeDialog from '@/views/personalNew/components/mobile/referral/wechatBindQrCodeDialog.vue'
import { addI18nProperty } from '@/i18n'
import { deviceType } from '@/utils/common'

export default {
  components: {
    ReferralCard,
    WeChatBindQrCodeDialog
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.leads',
      loading: false,
      potentialList: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 20,
        totalPage: 1
      },
      showWeChatBindQrCodeDialog: false
    }
  },
  computed: {
    ...mapGetters('account', ['wxUserHasBindRewards']),
    isPc () {
      return deviceType.isPc
    },
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
    this.getPotentialDate(true)
  },
  mounted () {

  },
  methods: {
    ...mapActions('personal', ['getMyAppliedPotentialCandidate']),
    handleGetQrCode () {
      if (!this.companyId) {
        return
      }
      this.showWeChatBindQrCodeDialog = true
    },
    async getPotentialDate (resetPage) {
      if (this.loading) {
        return
      }
      const page = resetPage ? 1 : this.pageInfo.currentPage + 1
      if (page > this.pageInfo.totalPage) {
        return
      }

      this.loading = true
      const params = {
        page: page,
        page_size: this.pageInfo.pageSize,
        company_id: this.companyId
      }
      try {
        const resp = await this.getMyAppliedPotentialCandidate(params)
        if (resp) {
          this.pageInfo.totalPage = resp.total_pages
          this.pageInfo.currentPage = resp.page_num
          const results = this.formatResult(resp.results)
          this.potentialList = _.concat(this.potentialList, results)
        }
      } finally {
        this.loading = false
      }
    },
    formatResult (results) {
      _.forEach(results, result => {
        addI18nProperty(result.job, 'jobTitle', 'cn_title', 'title')
        _.forEach(result.referral_chain, item => {
          addI18nProperty(item.city, 'cityName', 'cn_name', 'name')
        })
      })
      return results
    },
    handleScroll () {
      this.getPotentialDate()
    }
  }
}
</script>

<style lang="scss" scoped>
.applied-potential-page {
  .applied-potential-container {
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(235px, 0));
    row-gap: 24px;
    column-gap: 18px;
    align-items: center;
    justify-content: space-between;

    .get-rewards {
      position: absolute;
      top: -64px;
      right: 0;

      .get-rewards-btn {
        height: 30px;
        padding: 0 14px;
        border-radius: 4px;
        color: #fff;
        border-color: #0096cc;
        background-color: #0096cc;
      }
    }

    .applied-potential-list {
      ::v-deep .referral-content {
        position: relative;
      }

      .status {
        position: absolute;
        top: 4px;
        right: 4px;
        padding: 0 8px;
        border-radius: 12px;
        background-color: #0096cc;
        min-width: 60px;
        text-align: center;
        font-size: 12px;
        line-height: 24px;
        color: #fff;
      }
    }
  }

  .tip {
    text-align: center;
    padding-top: 20px;
  }
}
</style>
